
export const stringFromRepetition = (txt, count) => {
  let result = ''
  for (let i = 0; i < count; i++) {
    result += txt
  }
  return result
}

export const toCsString = (value, min, max = min) => {
  const LOCALES = 'cs-CZ'
  if (min === undefined) {
    return value.toLocaleString(LOCALES)
  }
  return value.toLocaleString(LOCALES, {
    minimumFractionDigits: min,
    maximumFractionDigits: max
  })
}
